
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';

// Internal
import { Loading } from '@/components';
import ItemListGruppoDistinteConsumi from "./ItemListGruppoDistinteConsumi.vue";
import { Utente, GruppoDistinte } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';

@Component({
  components: {
    Loading,
    ItemListGruppoDistinteConsumi
  }
})
export default class GruppoDistinteConsumiList extends Vue {

  get loading() { return store.state.loading; }

  get user() { return store.state.currentUsr; }

  get userIsAdmin() {
    return (
      this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
      undefined
    );
  }

  get gruppi(): GruppoDistinte[] {
    return store.state.uiConsumi.listaGruppiDistinte;
  }

  created(): void {
  }

}
